import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-device-selector-modal',
  templateUrl: './device-selector-modal.component.html',
  styleUrls: ['./device-selector-modal.component.scss'],
})
export class DeviceSelectorModalComponent {
  @Input() devices: MediaDeviceInfo[];
  @Input() selectedDeviceId: string;
  @Input() onSelectDevice: (deviceId: string) => void;

  selectDevice(deviceId: string) {
    this.onSelectDevice(deviceId);
  }
}
